<template>
  
     <div class="bg-white overflow-hidden shadow-sm p-3 sm:rounded-xs border my-3">
      <DxChart
    id="chart"
    :data-source="timeOverview"
    palette="blue"
    title="Timing Overview"
  >
    <DxCommonSeriesSettings
    argument-field="date"
    type="rangebar"
    :min-bar-size="1"
    />
    <DxSeries 
      range-value1-field="in"
      range-value2-field="out"
    />

    <DxTooltip
      :enabled="true"
    />

    <DxArgumentAxis>
      <DxLabel format="date"/>
    </DxArgumentAxis>
    <DxValueAxis title="Time" :visual-range="visualRange" :tick-interval="7"/>

    <DxExport :enabled="true"/>
    <DxLegend
      vertical-alignment="bottom"
      horizontal-alignment="center"
    />
  </DxChart>
     </div>
 
</template>

<script >
import JetButton from '@/Jetstream/Button.vue'
import DxChart, {
  DxCommonSeriesSettings,
  DxSeries,
  DxArgumentAxis,
  DxValueAxis,
  DxLabel,
  DxExport,
  DxLegend,
  DxTooltip,
} from 'devextreme-vue/chart';
export default {
  props: {
   
  },
   components: {
    JetButton,
    DxChart,
    DxCommonSeriesSettings,
    DxSeries,
    DxArgumentAxis,
    DxValueAxis,
    DxLabel,
    DxExport,
    DxLegend,
    DxTooltip,
    
   },
   
   data() {
     
   return {
    timeOverview : [{
  date: new Date(2024, 0, 4),
  in: 34.33,
  out: 43.29, 
}, {
  date: new Date(2024, 1, 1),
  in: 42.24,
  out: 47.07,
}, {
  date: new Date(2024, 2, 1),
  in: 42.93,
  out: 52.77,
}, {
  date: new Date(2024, 3, 1),
  in: 44.24,
  out: 54.14,
}, {
  date: new Date(2024, 4, 1),
  in: 44.47,
  out: 49.03,
}, {
  date: new Date(2024, 5, 1),
  in: 50.55,
  out: 57.94,
}, {
  date: new Date(2024, 6, 1),
  in: 52.79,
  out: 58.98,
}, {
  date: new Date(2024, 7, 1),
  in: 56.49,
  out: 67.06,
}, {
  date: new Date(2024, 8, 1),
  in: 62.77,
  out: 66.72,
}, {
  date: new Date(2024, 9, 1),
  in: 57.52,
  out: 63.47,
}, {
  date: new Date(2024, 10, 1),
  in: 52.92,
  out: 59.98,  
}, {
  date: new Date(2024, 11, 1),
  low: 55.22,
  out: 55.22,
}],
visualRange: [0, 100],
labelsIWantToSee: ["0", "50", "80", "100"],
   };
 },

 methods: {
 
 },
 computed: {
  
 },
 mounted() {
// console.log('timeoverview:',  this.timeOverview[1]);
 }

}

</script>

<style >
p {
   margin-top: 0;
   margin-bottom: 0.1rem;
}

h2{
   margin-bottom: 0.1rem;   
}
#chart {
  height: 440px;
}

</style>